import { Box, useTheme } from "@mui/material";
import SecondaryBox from "../../atoms/box/SecondaryBox";
import { ScreenSmallerThen } from "../../utilities/UIHelper";
import { RectangularLoader } from "../../molecules/skeleton-loader/RectangularLoader";
import { GraphLoader } from "../../organisms/skeleton-loaders/GraphLoader";
import { ListViewLoader } from "./ListViewLoader";
import { IColumnVisibility } from "../../molecules/ColumnVisibility";

export const EvaluationRunLoader = () => {
  const theme = useTheme();
  const isSmallScreen = ScreenSmallerThen();
  const columnsVisibility: IColumnVisibility<any>[] = [
    {
      field: "name",
      headerName: "Name",
      visible: true,
      columnMinWidth: 400,
    },
    {
      field: "reason",
      headerName: "Reason",
      visible: true,
      columnMinWidth: 400,
    },
    {
      field: "id",
      headerName: "",
      visible: true,
      columnMaxWidth: 60,
      columnMinWidth: 60,
    },
  ];

  return (
    <Box paddingBottom="80px">
      <Box height="100%" gap="15px" display="flex" flexDirection="column" overflow="auto">
        <SecondaryBox padding="0px">
          <Box padding="10px" borderBottom={`1px solid ${theme.palette.custom.secondaryBorder}`}>
            <RectangularLoader width="100%" height="60px" />
          </Box>
          <Box display="flex" flexDirection={isSmallScreen ? "column" : "row"}>
            <Box
              width={isSmallScreen ? "100%" : "50%"}
              padding="10px"
              display="flex"
              flexDirection="column"
              gap="10px"
              justifyContent="space-between"
            >
              <RectangularLoader width="100%" height="24px" />
              <RectangularLoader width="100%" height="24px" />
            </Box>
            <Box
              width={isSmallScreen ? "100%" : "50%"}
              padding="10px"
              display="flex"
              flexDirection="column"
              gap="10px"
              borderLeft={isSmallScreen ? "0" : `1px solid ${theme.palette.custom.secondaryBorder}`}
              borderTop={!isSmallScreen ? "0" : `1px solid ${theme.palette.custom.secondaryBorder}`}
            >
              <RectangularLoader width="100%" height="24px" />
              <RectangularLoader width="100%" height="24px" />
            </Box>
          </Box>
        </SecondaryBox>
        <SecondaryBox padding="10px">
          <RectangularLoader width="100%" height="30px" />
        </SecondaryBox>
        <ListViewLoader
          columnsVisibility={columnsVisibility}
          tableSize="small"
          paddingBottom={false}
        />
        <ListViewLoader
          columnsVisibility={columnsVisibility}
          tableSize="small"
          paddingBottom={false}
        />
        <ListViewLoader
          columnsVisibility={columnsVisibility}
          tableSize="small"
          paddingBottom={false}
        />
      </Box>
    </Box>
  );
};
